import { Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
  Gender,
  Marital_Status,
  Race,
  Residence,
  Titles,
  nationalityList,
} from '../../common/Constants';
import { Field, Formik, ErrorMessage } from 'formik';
import { InitialData } from '../../common/InitialData';
import { ServerAPI } from '../../common/ServerAPI';
import dayjs from 'dayjs';
import { RequiredFields } from '../../common/RequiredFields';
import {
  checkValidations,
  convertObject,
  signInDisabled,
  hasKeysAndNotEmpty,
  reverseObject,
} from '../../common/Utilities';
import { toast } from 'react-toastify';

const PersonalDetails = ({
  type,
  guarantor_index,
  updateFunction,
  productData,
  SingPassData,
}) => {
  const [isSingpassDataAdded, setSingpassDataAdded] = useState(0);
  const [applicantDetails, setApplicantDetails] = useState({});
  const [disabledApplicantDetails, setDisabledApplicantDetails] = useState({});

  const [applicantType, setApplicantType] = useState('');
  const [emailMessage, setEmailMessage] = useState('Email Required');
  const [validationDetails, setValidationDetails] = useState({});

  const handleBlur = async (e, formikProps) => {
    const { name, value } = e.target;
   

    let updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(formikProps.values)
        : { ...validationDetails };
    updateData[name]['validation'] = value != '' ? true : false;
    updateData[name]['value'] = value;
    if (name == 'email') {
      if (value.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)) {
        updateData['email']['validation'] = true;
      } else if (value == '') {
        setEmailMessage('email Required');
      } else {
        setEmailMessage('Invalid Email');
        updateData['email']['validation'] = false;
      }
    }
    if (name === 'name') {
      if (value?.length < 8) {
        updateData['name']['validation'] = false;
      }
    }
    if (name === 'mobile_no') {
      if (value?.length < 8) {
        updateData['mobile_no']['validation'] = false;
      }
    }
    if (name === 'postal_code') {
      if (value?.length < 6) {
        updateData['postal_code']['validation'] = false;
      }
    }
    if (name === 'mobile_no') {
      updateData['office']['validation'] = true;
    }
    if (applicantType != 'Company') {
      if (name === 'mobile_no') {
        updateData['home_no']['validation'] = true;
      }
    }

    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    setApplicantDetails(formikProps.values);
    setValidationDetails(updateData);
    localStorage.setItem('applicant_details', JSON.stringify(updateData));
  };

  const handleChange = (e, formikProps) => {
    let data = { ...formikProps.values };
    const { name, value } = e.target;
    let updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(data)
        : validationDetails;
    updateData[name]['validation'] = value != '' ? true : false;
    updateData[name]['value'] = value;
    if (name == 'home_address_same_as_mailing' && value == 0) {
      data['home_address_same_as_mailing'] = 0;
      formikProps.setFieldValue(name, 0);
      formikProps.setFieldTouched(name, true);
      updateData['home_address_same_as_mailing']['value'] = 0;
      updateData['home_address_same_as_mailing']['validation'] = true;
      updateData['mailing_home_address']['validation'] = false;
      updateData['mailing_postal_code']['validation'] = false;
      updateData['mailing_residence_type']['validation'] = false;
    } else if (name == 'home_address_same_as_mailing' && value == 1) {
      formikProps.setFieldValue(name, 1);
      formikProps.setFieldTouched(name, true);
      data['home_address_same_as_mailing'] = 1;
      updateData['home_address_same_as_mailing']['value'] = 1;
      updateData['home_address_same_as_mailing']['validation'] = true;
      updateData['mailing_home_address']['validation'] = true;
      updateData['mailing_postal_code']['validation'] = true;
      updateData['mailing_residence_type']['validation'] = true;
    } else if (name == 'company_address_same_as_mailing' && value == 0) {
      formikProps.setFieldValue(name, 0);
      formikProps.setFieldTouched(name, true);
      data['company_address_same_as_mailing'] = 0;
      updateData['company_address_same_as_mailing']['validation'] = true;
      updateData['company_address_same_as_mailing']['value'] = 0;
      updateData['mailing_company_address']['validation'] = false;
      updateData['mailing_company_postal_code']['validation'] = false;
    } else if (name == 'company_address_same_as_mailing' && value == 1) {
      formikProps.setFieldValue(name, 1);
      formikProps.setFieldTouched(name, true);
      updateData['company_address_same_as_mailing']['validation'] = true;
      updateData['company_address_same_as_mailing']['value'] = 1;
      data['company_address_same_as_mailing'] = 1;
      updateData['mailing_company_address']['validation'] = true;
      updateData['mailing_company_postal_code']['validation'] = true;
    }
    setApplicantDetails(data);
    setValidationDetails(updateData);
    localStorage.setItem('applicant_details', JSON.stringify(updateData));
  };

  const handleDropdownChange = (name, value, formikProps) => {
    formikProps.setFieldValue(name, value);
    formikProps.setFieldTouched(name, true);
    let data = { ...formikProps.values };
    data[name] = value;
    let updateData =
      Object.keys(validationDetails).length == 0
        ? convertObject(data)
        : validationDetails;
    updateData[name]['validation'] = value != '' ? true : false;
    updateData[name]['value'] = value;
    if (name == 'marital_status' && value == 'Single') {
      updateData['name_of_spouse']['validation'] = true;
    }
    setApplicantDetails(data);
    setValidationDetails(updateData);
    localStorage.setItem('applicant_details', JSON.stringify(updateData));
  };

  useEffect(() => {
    let applicantTypeData = localStorage.getItem('applicanttype');
    if (applicantTypeData) {
      setApplicantType(applicantTypeData);
    }
    let savedValues = {};
    savedValues = localStorage.getItem('applicant_details');
    if (savedValues && Object.keys(savedValues).length != 0) {
      let parsedValues = JSON.parse(savedValues);
      setValidationDetails(parsedValues);
      //parsedValues = reverseObject(parsedValues);
      parsedValues = Object.entries(parsedValues).reduce((acc, [key, { value, disabled }]) => {
        acc[key] = value;
        if (disabled != undefined) {
          acc[key + '_disabled'] = disabled;
        }
        return acc;
      }, {});
      setApplicantDetails(parsedValues);
    } else {
      if (applicantTypeData) {
        if (
          applicantTypeData == 'Singapore Citizen' ||
          applicantTypeData == 'Permenant Resident(PR)'
        ) {
          setApplicantDetails(InitialData.applicant_details);
        } else if (applicantTypeData == 'Work Pass Holder(FIN)') {
          setApplicantDetails(InitialData.applicant_details_work_pass);
        } else if (applicantTypeData == 'Foreign Work Pass(Passport)') {
          setApplicantDetails(InitialData.applicant_details_foreign);
        } else {
          setApplicantDetails(InitialData.applicant_details_company);
        }
      }
    }
    const capitalizedArray = nationalityList.map((item) => {
      return {
        label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
        value: item.value.charAt(0).toUpperCase() + item.value.slice(1),
      };
    });

  }, []);

  useEffect(() => {
    if (
      SingPassData !== undefined &&
      SingPassData !== null &&
      Object.keys(SingPassData)?.length > 0 && isSingpassDataAdded === 0
    ) {
      setSingpassDataAdded((prevKey) => prevKey + 1);
      setApplicantDetails(SingPassData);
    }
  });


  return (
    <div>
      {applicantType != 'Company' && (
        <Formik enableReinitialize={true} initialValues={applicantDetails}>
          {(formikProps) => (
            <Form>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Title</label>
                  <Form.Item>
                    {' '}
                    <Field>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='title'
                          className='w-full md:w-[230px]'
                          onChange={(e) => {
                            handleDropdownChange('title', e, formikProps);
                          }}
                          options={Titles}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('title') : false}
                          value={applicantDetails.title}
                        />
                      )}
                    </Field>
                    {validationDetails?.title?.validation == false && (
                      <span className='error'>Title Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Name</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='name'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('name') : false}
                        />
                      )}
                    </Field>
                    {validationDetails?.name?.validation == false && (
                      <span className='error'>Name Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  {(applicantType == 'Singapore Citizen' ||
                    applicantType == 'Permenant Resident(PR)') && (
                      <Fragment>
                        <label>NRIC</label>
                        <Form.Item name='field2' className='mt-1'>
                          <Field name='nric'>
                            {({ field }) => (
                              <Input
                                {...field}
                                onBlur={(e) => handleBlur(e, formikProps)}
                                disabled={productData?.missing_fields ? !productData.missing_fields.includes('nric') : false}
                              />
                            )}
                          </Field>
                          {validationDetails?.nric?.validation == false && (
                            <span className='error'>NRIC Required</span>
                          )}
                        </Form.Item>
                      </Fragment>
                    )}
                  {applicantType == 'Work Pass Holder(FIN)' && (
                    <Fragment>
                      <label className='form-field-label'>FIN No</label>
                      <Form.Item name='field2' className='mt-1'>
                        <Field name='fin_no'>
                          {({ field }) => (
                            <Input
                              {...field}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.fin_no?.validation == false && (
                          <span className='error'>FIN No Required</span>
                        )}
                      </Form.Item>
                    </Fragment>
                  )}
                  {applicantType == 'Foreign Work Pass(Passport)' && (
                    <Fragment>
                      <label className='form-field-label'>Passport No</label>
                      <Form.Item name='field2' className='mt-1'>
                        <Field name='passport_no'>
                          {({ field }) => (
                            <Input
                              {...field}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.passport_no?.validation ==
                          false && (
                            <span className='error'>Passport No Required</span>
                          )}
                      </Form.Item>
                    </Fragment>
                  )}
                </div>
                {(applicantType == 'Singapore Citizen' ||
                  applicantType == 'Permenant Resident(PR)') && (
                    <div className='input-group w-full md:w-[230px]'>
                      <label>Date of Birth</label>
                      <Form.Item name='field2' className='mt-1 w-full'>
                        <Field name='dob'>
                          {({ field }) => (
                            <DatePicker
                              placeholder='DD-MM-YYYY'
                              className={`py-[8px] w-full md:w-[230px]`}
                              allowClear={false}
                              format='DD-MM-YYYY'
                              {...field}
                              value={
                                applicantDetails.dob
                                  ? dayjs(applicantDetails.dob)
                                  : null
                              }
                              name='dob'
                              disabled={productData?.missing_fields ? !productData.missing_fields.includes('dob') : false}
                              onChange={(date) => {
                                handleDropdownChange(
                                  'dob',
                                  dayjs(date).format('YYYY-MM-DD'),
                                  formikProps
                                );
                              }}
                              changeOnBlur
                              disabledDate={(d) => d.isAfter(dayjs())}
                            />
                          )}
                        </Field>
                        {validationDetails?.dob?.validation == false && (
                          <span className='error'>DOB Required</span>
                        )}
                      </Form.Item>
                    </div>
                  )}
                {(applicantType == 'Work Pass Holder(FIN)' ||
                  applicantType == 'Foreign Work Pass(Passport)') && (
                    <Fragment>
                      <div xs={24} sm={12} md={4} lg={6}>
                        <label className='form-field-label'>
                          Nationality/Country
                        </label>
                        <Form.Item className='mt-1 w-full'>
                          <Field name='nationality'>
                            {({ field }) => (
                              <Select
                                showSearch
                                filterOption={(input, option) =>
                                  (option?.label ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                filterSort={(optionA, optionB) =>
                                  (optionA?.label ?? '')
                                    .toLowerCase()
                                    .localeCompare(
                                      (optionB?.label ?? '').toLowerCase()
                                    )
                                }
                                {...field}
                                name='nationality'
                                onChange={(e) => {
                                  handleDropdownChange(
                                    'nationality',
                                    e,
                                    formikProps
                                  );
                                }}
                                options={nationalityList}
                                value={applicantDetails.nationality}
                              />
                            )}
                          </Field>
                          {validationDetails?.nationality?.validation ==
                            false && (
                              <span className='error'>Nationality Required</span>
                            )}
                        </Form.Item>
                      </div>
                    </Fragment>
                  )}
              </div>
              {(applicantType == 'Work Pass Holder(FIN)' ||
                applicantType == 'Foreign Work Pass(Passport)') && (
                  <div className='input-one-line-dealer' gutter={[24, 24]}>
                    <div className='input-group w-full md:w-[230px]'>
                      <label>Passport Expiry</label>
                      <Form.Item name='field2' className='mt-1 w-full'>
                        <Field name='passport_expiry_date'>
                          {({ field }) => (
                            <DatePicker
                              placeholder='DD-MM-YYYY'
                              className='w-full'
                              allowClear={false}
                              format='DD-MM-YYYY'
                              {...field}
                              value={
                                applicantDetails.passport_expiry_date
                                  ? dayjs(applicantDetails.passport_expiry_date)
                                  : null
                              }
                              name='passport_expiry_date'
                              onChange={(date) => {
                                handleDropdownChange(
                                  'passport_expiry_date',
                                  dayjs(date).format('YYYY-MM-DD'),
                                  formikProps
                                );
                              }}
                            />
                          )}
                        </Field>
                        {validationDetails?.passport_expiry_date?.validation ==
                          false && (
                            <span className='error'>Passport Expiry Required</span>
                          )}
                      </Form.Item>
                    </div>
                    <div className='input-group w-full md:w-[230px]'>
                      <label>Date of Birth</label>
                      <Form.Item name='field2' className='mt-1 w-full'>
                        <Field name='dob'>
                          {({ field }) => (
                            <DatePicker
                              placeholder='DD-MM-YYYY'
                              className={`py-[8px] w-full md:w-[230px]`}
                              allowClear={false}
                              format='DD-MM-YYYY'
                              {...field}
                              value={
                                applicantDetails.dob
                                  ? dayjs(applicantDetails.dob)
                                  : null
                              }
                              name='dob'
                              onChange={(date) => {
                                handleDropdownChange(
                                  'dob',
                                  dayjs(date).format('YYYY-MM-DD'),
                                  formikProps
                                );
                              }}
                              changeOnBlur
                              disabledDate={(d) => d.isAfter(dayjs())}
                            />
                          )}
                        </Field>
                        {validationDetails?.dob?.validation == false && (
                          <span className='error'>DOB Required</span>
                        )}
                      </Form.Item>
                    </div>
                    <div className='input-group w-full md:w-[230px]'>
                      <label>Gender</label>
                      <Form.Item className='mt-1 w-full'>
                        <Field name='gender'>
                          {({ field }) => (
                            <Select
                              {...field}
                              name='gender'
                              onChange={(e) => {
                                handleDropdownChange('gender', e, formikProps);
                              }}
                              options={Gender}
                              value={applicantDetails.gender}
                            />
                          )}
                        </Field>
                        {validationDetails?.gender?.validation == false && (
                          <span className='error'>Gender Required</span>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                )}
              <div className='input-one-line-dealer' gutter={[24, 24]}>
                {applicantType != 'Work Pass Holder(FIN)' &&
                  applicantType != 'Foreign Work Pass(Passport)' && (
                    <div className='input-group w-full md:w-[230px]'>
                      <label>Gender</label>
                      <Form.Item className='mt-1 w-full'>
                        <Field name='gender'>
                          {({ field }) => (
                            <Select
                              {...field}
                              name='gender'
                              onChange={(e) => {
                                handleDropdownChange('gender', e, formikProps);
                              }}
                              options={Gender}
                              disabled={productData?.missing_fields ? !productData.missing_fields.includes('gender') : false}
                              value={applicantDetails.gender}
                            />
                          )}
                        </Field>
                        {validationDetails?.gender?.validation == false && (
                          <span className='error'>Gender Required</span>
                        )}
                      </Form.Item>
                    </div>
                  )}
                <div className='input-group w-full md:w-[230px]'>
                  <label>Race</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='race'>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='race'
                          onChange={(e) => {
                            handleDropdownChange('race', e, formikProps);
                          }}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('race') : false}

                          options={Race}
                          value={applicantDetails.race}
                        />
                      )}
                    </Field>
                    {validationDetails?.race?.validation == false && (
                      <span className='error'>Race Required</span>
                    )}
                  </Form.Item>
                </div>
                <div
                  className='input-group w-full md:w-[230px]'
                  xs={24}
                  sm={12}
                  md={4}
                  lg={
                    applicantType != 'Work Pass Holder(FIN)' &&
                      applicantType != 'Foreign Work Pass(Passport)'
                      ? 4
                      : 6
                  }
                >
                  <label>Marital Status</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='marital_status'>
                      {({ field }) => (
                        <Field>
                          {({ field }) => (
                            <Select
                              {...field}
                              name='marital_status'
                              onChange={(e) => {
                                handleDropdownChange(
                                  'marital_status',
                                  e,
                                  formikProps
                                );
                              }}
                              disabled={false}
                              options={Marital_Status}
                              value={applicantDetails.marital_status}
                            />
                          )}
                        </Field>
                      )}
                    </Field>
                    {validationDetails?.marital_status?.validation == false && (
                      <span className='error'>Marital Status Required</span>
                    )}
                  </Form.Item>
                </div>
                {formikProps.values.marital_status == 'Married' && (
                  <div
                    className='input-group w-full md:w-[230px]'
                    xs={24}
                    sm={12}
                    md={8}
                    lg={
                      applicantType != 'Work Pass Holder(FIN)' &&
                        applicantType != 'Foreign Work Pass(Passport)'
                        ? 7
                        : 8
                    }
                  >
                    <label className='form-field-label ml-2'>
                      Name of Spouse
                    </label>
                    <Form.Item name='field2' className='mt-1 ml-2'>
                      <Field name='name_of_spouse'>
                        {({ field }) => (
                          <Input
                            {...field}
                            onBlur={(e) => handleBlur(e, formikProps)}
                            // disabled={productData?.missing_fields ? !productData.missing_fields.includes('name_of_spouse') : false}

                          />
                        )}
                      </Field>
                      {validationDetails?.name_of_spouse?.validation ==
                        false && (
                          <span className='error'>Name of Spouse Required</span>
                        )}
                    </Form.Item>
                  </div>
                )}
              </div>
              <div className='input-one-line-dealer' gutter={[24, 24]}>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Home Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='home_no'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('home_no') : false}

                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>

                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Mobile</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='mobile_no'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          disabled={applicantDetails.mobile_no}

                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.mobile_no?.validation == false && (
                      <span className='error'>Mobile Number Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Office</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='office'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('office') : false}

                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Email</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='email'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('email') : false}

                        />
                      )}
                    </Field>
                    {validationDetails?.email?.validation == false && (
                      <span className='error'>{emailMessage}</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer' gutter={[24, 24]}>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Residence Type</label>
                  <Form.Item className='mt-1 w-full'>
                    <Field name='residence_type'>
                      {({ field }) => (
                        <Select
                          {...field}
                          name='residence_type'
                          onChange={(e) => {
                            handleDropdownChange(
                              'residence_type',
                              e,
                              formikProps
                            );
                          }}
                          options={Residence}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('residence_type') : false}

                          value={applicantDetails.residence_type}
                        />
                      )}
                    </Field>
                    {validationDetails?.residence_type?.validation == false && (
                      <span className='error'>Residence Type Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Home Address</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='home_address'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('home_address') : false}

                        />
                      )}
                    </Field>
                    {validationDetails?.home_address?.validation == false && (
                      <span className='error'>Home Address Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Postal Code</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='postal_code'>
                      {({ field }) => (
                        <Input
                          maxLength={6}
                          minLength={6}
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                          disabled={productData?.missing_fields ? !productData.missing_fields.includes('postal_code') : false}
                        />
                      )}
                    </Field>
                    {validationDetails?.postal_code?.validation == false && (
                      <span className='error'>Postal Code Required</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer' gutter={[24, 24]}>
                <div className='input-group w-full md:w-[230px]'>
                  <label>Home address same as mailing address?</label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='home_address_same_as_mailing'>
                      {({ field }) => (
                        <Radio.Group
                          {...field}
                          onChange={(e) => handleChange(e, formikProps)}
                        >
                          <Radio key={1} value={1}>
                            <p className='form-field-label'>Yes</p>
                          </Radio>
                          <Radio key={0} value={0}>
                            <p className='form-field-label'>No</p>
                          </Radio>
                        </Radio.Group>
                      )}
                    </Field>
                    <br />
                    {validationDetails?.home_address_same_as_mailing
                      ?.validation == false && (
                        <span className='error'>Required</span>
                      )}
                  </Form.Item>
                </div>
              </div>
              {formikProps.values.home_address_same_as_mailing == 0 &&
                validationDetails?.home_address_same_as_mailing?.validation ==
                true && (
                  <div className='input-one-line-dealer'>
                    <div className='input-group w-full md:w-[230px]'>
                      <label className='form-field-label'>
                        Mailing Residence Type
                      </label>
                      <Form.Item className='mt-1 w-full'>
                        <Field name='mailing_residence_type'>
                          {({ field }) => (
                            <Select
                              {...field}
                              name='mailing_residence_type'
                              onChange={(e) => {
                                handleDropdownChange(
                                  'mailing_residence_type',
                                  e,
                                  formikProps
                                );
                              }}
                              options={Residence}
                              value={applicantDetails.mailing_residence_type}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_residence_type
                          ?.validation == false && (
                            <span className='error'>
                              Mailing Residence Type Required
                            </span>
                          )}
                      </Form.Item>
                    </div>
                    <div className='input-group w-full md:w-[230px]'>
                      <label className='form-field-label'>
                        Mailing Address
                      </label>
                      <Form.Item name='field3' className='mt-1'>
                        <Field name='mailing_home_address'>
                          {({ field }) => (
                            <Input
                              {...field}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_home_address?.validation ==
                          false && (
                            <span className='error'>
                              Mailing Address Required
                            </span>
                          )}
                      </Form.Item>
                    </div>
                    <div className='input-group w-full md:w-[230px]'>
                      <label className='form-field-label'>
                        Mailing Postal Code
                      </label>
                      <Form.Item name='field3' className='mt-1'>
                        <Field name='mailing_postal_code'>
                          {({ field }) => (
                            <Input
                              maxLength={6}
                              minLength={6}
                              {...field}
                              onBlur={(e) => handleBlur(e, formikProps)}
                            />
                          )}
                        </Field>
                        {validationDetails?.mailing_postal_code?.validation ==
                          false && (
                            <span className='error'>
                              Mailing Postal Code Required
                            </span>
                          )}
                      </Form.Item>
                    </div>
                  </div>
                )}
            </Form>
          )}
        </Formik>
      )}
      {applicantType == 'Company' && (
        <Formik enableReinitialize={true} initialValues={applicantDetails}>
          {(formikProps) => (
            <Form layout='vertical'>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Company Name</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='company_name'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.company_name?.validation == false && (
                      <span className='error'>Company Name Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>UEN/ACRA No:</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='uen_acra_no'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.uen_acra_no?.validation == false && (
                      <span className='error'>UEN/ACRA No Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>
                    Date of Incorporation
                  </label>
                  <Form.Item name='field2' className='mt-1 w-full'>
                    <Field name='date_of_incorporation'>
                      {({ field }) => (
                        <DatePicker
                          placeholder='DD-MM-YYYY'
                          className='w-full'
                          allowClear={false}
                          format='DD-MM-YYYY'
                          {...field}
                          value={
                            applicantDetails.date_of_incorporation
                              ? dayjs(applicantDetails.date_of_incorporation)
                              : null
                          }
                          name='date_of_incorporation'
                          onChange={(date) => {
                            handleDropdownChange(
                              'date_of_incorporation',
                              dayjs(date).format('YYYY-MM-DD'),
                              formikProps
                            );
                          }}
                        />
                      )}
                    </Field>
                    {validationDetails?.date_of_incorporation?.validation ==
                      false && (
                        <span className='error'>
                          Date of Incorporation Required
                        </span>
                      )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Mobile Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='mobile_no'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.mobile_no?.validation == false && (
                      <span className='error'>Mobile Number Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Office Number</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='office'>
                      {({ field }) => (
                        <Input
                          maxLength={8}
                          addonBefore={'+65'}
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label ml-2'>Email</label>
                  <Form.Item name='field2' className='mt-1 ml-2'>
                    <Field name='email'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.email?.validation == false && (
                      <span className='error'>{emailMessage}</span>
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Contact Person</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='name'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.name?.validation == false && (
                      <span className='error'>Contact person Required</span>
                    )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Company Address</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='company_address'>
                      {({ field }) => (
                        <Input
                          {...field}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.company_address?.validation ==
                      false && (
                        <span className='error'>Company Address Required</span>
                      )}
                  </Form.Item>
                </div>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>Postal Code</label>
                  <Form.Item name='field2' className='mt-1'>
                    <Field name='company_postal_code'>
                      {({ field }) => (
                        <Input
                          {...field}
                          maxLength={6}
                          minLength={6}
                          onBlur={(e) => handleBlur(e, formikProps)}
                        />
                      )}
                    </Field>
                    {validationDetails?.company_postal_code?.validation ==
                      false && (
                        <span className='error'>
                          Postal Code must have 6 digits
                        </span>
                      )}
                  </Form.Item>
                </div>
              </div>

              <div className='input-one-line-dealer'>
                <div className='input-group w-full md:w-[230px]'>
                  <label className='form-field-label'>
                    Company address same as mailing address?
                  </label>
                  <Form.Item name='field3' className='mt-1'>
                    <Field name='company_address_same_as_mailing'>
                      {({ field }) => (
                        <Radio.Group
                          {...field}
                          onChange={(e) => handleChange(e, formikProps)}
                        >
                          <Radio key={1} value={1}>
                            <p className='form-field-label'>Yes</p>
                          </Radio>
                          <Radio key={0} value={0}>
                            <p className='form-field-label'>No</p>
                          </Radio>
                        </Radio.Group>
                      )}
                    </Field>
                    <br />
                    {validationDetails?.company_address_same_as_mailing
                      ?.validation == false &&
                      formikProps.values.company_address_same_as_mailing ==
                      '' && <span className='error'> Required</span>}
                  </Form.Item>
                </div>
              </div>
              {formikProps.values.company_address_same_as_mailing == 0 &&
                validationDetails?.company_address_same_as_mailing
                  ?.validation == true && (
                  <>
                    <div className='input-one-line-dealer'>
                      <div className='input-group w-full md:w-[230px]'>
                        <label className='form-field-label'>
                          Mailing Company Address
                        </label>
                        <Form.Item name='field2' className='mt-1'>
                          <Field name='mailing_company_address'>
                            {({ field }) => (
                              <Input
                                {...field}
                                onBlur={(e) => handleBlur(e, formikProps)}
                              />
                            )}
                          </Field>
                          {validationDetails?.mailing_company_address
                            ?.validation == false && (
                              <span className='error'>
                                {' '}
                                Mailing Address Required
                              </span>
                            )}
                        </Form.Item>
                      </div>
                      <div className='input-group w-full md:w-[230px]'>
                        <label className='form-field-label'>
                          Mailing Postal Code
                        </label>
                        <Form.Item name='field2' className='mt-1'>
                          <Field name='mailing_company_postal_code'>
                            {({ field }) => (
                              <Input
                                {...field}
                                maxLength={6}
                                minLength={6}
                                onBlur={(e) => handleBlur(e, formikProps)}
                              />
                            )}
                          </Field>
                          {validationDetails?.mailing_company_postal_code
                            ?.validation == false && (
                              <span className='error'> Postal Code Required</span>
                            )}
                        </Form.Item>
                      </div>
                    </div>
                  </>
                )}
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default PersonalDetails;
